import permissions from 'constants/permissions'

const PRIVACY_PORTAL_CONFIGURATION_LIST = [
  {
    name: 'Gerenciar Tema',
    tag: permissions.PRIVACY_PORTAL_CONFIGURATION.MANAGE_THEME,
  },
  {
    name: 'Visualizar Formulário',
    tag: permissions.PRIVACY_PORTAL_CONFIGURATION.VIEW_FORM,
  },
  {
    name: 'Gerenciar Formulário',
    tag: permissions.PRIVACY_PORTAL_CONFIGURATION.MANAGE_FORM,
  },
]

export default PRIVACY_PORTAL_CONFIGURATION_LIST
